import { render, staticRenderFns } from "./skill-level-detail.vue?vue&type=template&id=27380509&scoped=true&"
import script from "./skill-level-detail.vue?vue&type=script&lang=js&"
export * from "./skill-level-detail.vue?vue&type=script&lang=js&"
import style0 from "./skill-level-detail.vue?vue&type=style&index=0&id=27380509&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27380509",
  null
  
)

export default component.exports